import React from "react";

const projects = [
  {
    name: "MuQuestionPaper",
    logo: "/img/muquestionpaper-logo.png",
    screenshot: "/img/muquestionpaper.jpg",
    url: "https://muquestionpaper.com",
    desc: "Online Q&A portal for competitive exams"
  },
  {
    name: "NewsRadarr",
    logo: "/img/newsradarr-logo.png",
    screenshot: "/img/newsradarr.jpg",
    url: "#",
    desc: "RSS-based news feed aggregator platform"
  },
  {
    name: "Onion Ride",
    logo: "/img/onionride-logo.png",
    screenshot: "/img/onionride.jpg",
    url: "#",
    desc: "All-in-one search engine utility"
  },
  {
    name: "PDF Drive Search",
    logo: "/img/pdfdrivesearch-logo.png",
    screenshot: "/img/pdfdrivesearch.jpg",
    url: "#",
    desc: "Document search platform"
  },
  {
    name: "SMGPL",
    logo: "/img/smgpl-logo.png",
    screenshot: "/img/smgpl.jpg",
    url: "#",
    desc: "Corporate import/export website for a logistics firm"
  },
  {
    name: "WordCounter",
    logo: "/img/wordcounter-logo.png",
    screenshot: "/img/wordcounter.jpg",
    url: "#",
    desc: "Online word and character counter tool"
  }
];

function PortfolioCard({ name, logo, screenshot, url, desc }) {
  return (
    <div className="rounded-2xl bg-white/80 dark:bg-[#23244d]/80 shadow-lg border border-[#e6e9f5] dark:border-[#23244d] backdrop-blur transition-transform duration-300 hover:scale-105 hover:shadow-2xl group flex flex-col overflow-visible">
      <div className="relative w-full aspect-video flex items-center justify-center overflow-visible">
        <img src={screenshot} alt={name + ' screenshot'}
          className="object-cover w-full h-full rounded-t-2xl z-10 shadow-lg"
          loading="lazy" width="480" height="270" />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent rounded-t-2xl pointer-events-none" />
        {/* Logo half-overlapping */}
        <div className="absolute left-1/2 bottom-0 translate-x-[-50%] translate-y-1/2 z-30">
          <div className="w-16 h-16 rounded-full bg-white dark:bg-[#23244d] shadow-lg flex items-center justify-center border-4 border-white dark:border-[#23244d]">
            <img src={logo} alt={name + ' logo'} className="object-contain w-10 h-10" loading="lazy" width="40" height="40" />
          </div>
        </div>
      </div>
      <div className="flex-1 flex flex-col items-center justify-between p-4 pt-14 mt-2">
        <h3 className="font-bold text-lg md:text-xl text-[#1b1c4e] dark:text-white mb-1 text-center group-hover:text-indigo-600 transition-colors duration-300">{name}</h3>
        <p className="text-[#23244d] dark:text-white/80 text-sm text-center mb-3 line-clamp-2 min-h-[2.5em]">{desc}</p>
        {url && url !== "#" && (
          <a href={url} target="_blank" rel="noopener noreferrer"
            className="inline-block mt-auto px-5 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg text-sm font-semibold shadow hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105">
            View Project
          </a>
        )}
      </div>
    </div>
  );
}

export default function Portfolio() {
  return (
    <section id="portfolio" className="max-w-7xl mx-auto py-20 px-4">
      <h2 className="text-3xl font-bold mb-8 text-[#1b1c4e] dark:text-white text-center">Portfolio Highlights</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((p) => (
          <PortfolioCard key={p.name} {...p} />
        ))}
      </div>
    </section>
  );
} 